import { axiosInstance, requestConfig } from 'network/apis';

import { URL_BILLING } from 'utils/constants';

export const callItemShop = async () => {
    return await axiosInstance(requestConfig('get', URL_BILLING, '/v2/item/getshopitems'));
};
